import type { ChatMessage } from "./chat-api";

/** O teto do `pageSize` da API (`ListChatMessagesQueryDto`). */
export const MENSAGENS_POR_CARGA = 100;

interface ListaDeMensagens {
  items: ChatMessage[];
  total: number;
}

interface ListaMensagens {
  listMessages: (conversationId: string, page?: number, pageSize?: number) => Promise<ListaDeMensagens>;
}

/**
 * TUT-545 — a API pagina em ordem de criação, então a página 1 é o COMEÇO da
 * conversa. A conversa com o escritório é uma só e não acaba: passando de uma
 * carga, a tela mostraria só o começo e a resposta nova sumiria ao recarregar.
 * Aqui vêm as mais recentes: a primeira chamada dá o total, e, se não couber,
 * as duas últimas páginas cobrem as últimas `MENSAGENS_POR_CARGA`.
 */
export async function carregarUltimasMensagens(
  cliente: ListaMensagens,
  conversationId: string,
): Promise<ListaDeMensagens> {
  const primeira = await cliente.listMessages(conversationId, 1, MENSAGENS_POR_CARGA);
  if (primeira.total <= MENSAGENS_POR_CARGA) return primeira;
  const ultima = Math.ceil(primeira.total / MENSAGENS_POR_CARGA);
  const [penultima, final] = await Promise.all([
    ultima - 1 > 1
      ? cliente.listMessages(conversationId, ultima - 1, MENSAGENS_POR_CARGA)
      : Promise.resolve(primeira),
    cliente.listMessages(conversationId, ultima, MENSAGENS_POR_CARGA),
  ]);
  // O cliente da demonstração ignora a página e devolve tudo: sem repetir.
  const vistas = new Set<string>();
  const items = [...penultima.items, ...final.items].filter((m) => !vistas.has(m.id) && vistas.add(m.id));
  return { items: items.slice(-MENSAGENS_POR_CARGA), total: final.total };
}
